export default __webpack_public_path__ + "static/media/vuesax-linear-people.9a399969.svg";